import Vue from 'vue';
import errorUtility from '../services/errorUtility'

export default Vue.mixin({
    methods: {
        runCommand(viewModel, loadingName, callback, throwExceptions) {
            viewModel[loadingName] = true;
            if (throwExceptions) {
                try {
                    return callback();
                }
                finally {
                    viewModel[loadingName] = false;
                }
            } else {
                try {
                    return callback();
                }
                catch (e) {
                    errorUtility.handleServerError(e);
                }
                finally {
                    viewModel[loadingName] = false;
                }
            }
        },

        async runAsyncCommand(viewModel, loadingName, callback, params, throwExceptions) {
            viewModel[loadingName] = true;
            if (throwExceptions) {
                try {
                    return params ? await callback(params) : await callback();
                }
                finally {
                    viewModel[loadingName] = false;
                }
            } else {
                try {
                    return params ? await callback(params) : await callback();
                }
                catch (e) {
                    errorUtility.handleServerError(e);
                }
                finally {
                    viewModel[loadingName] = false;
                }
            }
        }
    }
})
